package dev.lingvo.shared

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

/** Sharing is explicit; project-private remains the conservative default. */
@Serializable
enum class SavedTemplateVisibility { PROJECT, WORKSPACE }

/** A caller-generated id makes an exact retry safe without saving a different source revision. */
@Serializable
data class SaveDesignTemplateRequest(
    val id: String,
    val version: Int,
    val name: String,
    val visibility: SavedTemplateVisibility = SavedTemplateVisibility.PROJECT,
)

/** Immutable templates contain layout and caption placeholders, never captured image bytes. */
@Serializable
data class SavedDesignTemplateDto(
    val id: String,
    val name: String,
    val visibility: SavedTemplateVisibility,
    val platform: StorePlatform,
    val sourceVersion: Int,
    val schemaVersion: Int,
    val document: JsonObject,
    val sha256: String,
    val byteSize: Int,
    val createdBy: String,
    val createdAt: String,
)

/** Applying is a design append guarded by the destination's current version. */
@Serializable
data class ApplyDesignTemplateRequest(val baseVersion: Int)
